import { useEffect, useState } from "react";
import "./IntroSection.scss";
import { renderCategory } from "./renderCategory";

export default function IntroSection(props) {
  const [state, setState] = useState({});

  useEffect(() => {
    setState(renderCategory(props.category, props.subsubsector));
  }, [props.category]);

  return (
    <div className="intro-section-component">
      <div
        className="hero"
        style={{
          backgroundImage: `url(${state.image})`,
          backgroundPosition: "center",
        }}
      >
        <div
          className="overlay"
          style={{ background: `var(--${state.color})` }}
        >
          <div className="section pad-mobile">
            {state.icon}
            <span dangerouslySetInnerHTML={{ __html: state.name }} />
            {props.subsector && props.subsector?.toLowerCase() !== "list" && (
              <span style={{ fontSize: 48, opacity: 0.5 }}>·</span>
            )}
            {props.subsector && props.subsector?.toLowerCase() !== "list" && (
              <span>{props.subsector}</span>
            )}
            {props.subsubsector &&
              props.subsubsector?.toLowerCase() !== "list" && (
                <span style={{ fontSize: 48, opacity: 0.5 }}>·</span>
              )}
            {props.subsubsector !== "List" && (
              <span style={{ fontWeight: "bold" }}>{props.subsubsector}</span>
            )}
            {props.subsubsubsector && props.subsubsubsector !== "List" && (
              <span style={{ fontSize: 48, opacity: 0.5 }}>·</span>
            )}
            {props.subsubsubsector !== "List" && (
              <span>{props.subsubsubsector}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
